import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coveragesRelabel',
})
export class CoveragesRelabelPipe implements PipeTransform {
  private readonly _coverageTypesCode = 'CoverageTypes';

  transform(coverage: string, questionCode: string): string {
    if (questionCode !== this._coverageTypesCode) return coverage;

    if (coverage === 'Liability') return 'General Liability';
    else if (coverage === 'BOP') return "Business Owner's Policy";
    else return coverage;
  }
}
